import React, {useCallback, useContext, useEffect, useState} from 'react';
import {
	Card, CardActions,
	CardContent,
	CardHeader, Paper,
	Typography
} from "@mui/material";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import MonitoraggiIsolamentoTable from "./MonitoraggiIsolamentoTable";
import {useHistory, useParams} from "react-router-dom";
import clsx from "clsx";
import Grid from "@mui/material/Grid";
import PanoramaFishEyeTwoToneIcon from "@mui/icons-material/PanoramaFishEyeTwoTone";
import {amber, indigo} from "@mui/material/colors";
import {FocolaioContext} from "../../../focolai/detail/FocolaioDetailPage";
import MonitoraggiQuarantenaTable from "./MonitoraggiQuarantenaTable";
import {askForMonitoraggio} from "../../../../../services/QuaranteneServices";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AppContext} from "../../../../../App";

const MonitoraggiCard = ({soggetto, quarantena}) => {
	const classes = BaseStyle();
	const history = useHistory();
	let {id, idSoggetto} = useParams();
	const quarantenaContext = useContext(FocolaioContext);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	
	const goToAllMonitoraggi = useCallback(() => {
		history.push("/gestione/quarantene/" + (quarantena ? quarantena.id : id) + "/soggetto/" + (soggetto ? soggetto : idSoggetto) + "/monitoraggi");
	}, [history, id, idSoggetto, soggetto, quarantena]);
	
	const compilaMonitoraggio = useCallback(() => {
		history.push("/gestione/quarantene/" + (quarantena ? quarantena.id : id) + "/soggetto/" + (soggetto ? soggetto : idSoggetto) + "/monitoraggio");
	}, [history, id, idSoggetto, soggetto, quarantena]);
	
	const askAutocomplete = useCallback(() => {
		setSubmit(true);
		askForMonitoraggio(quarantena.id, quarantenaContext.dispatch);
	}, [quarantena.id, quarantenaContext.dispatch])
	
	useEffect(() => {
		if (submit && !quarantenaContext.state.loadingAskForMonitoraggio && quarantenaContext.state.errorAskForMonitoraggio === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Il monitoraggio è stato inviato via mail all'utente", appContext.dispatch);
		} else if (submit && !quarantenaContext.state.loadingAskForMonitoraggio && quarantenaContext.state.errorAskForMonitoraggio !== "") {
			setSubmit(false);
			setOpenSnackbar("success", quarantenaContext.state.errorAskForMonitoraggio, appContext.dispatch);
		}
	}, [submit, quarantenaContext.state.loadingAskForMonitoraggio, quarantenaContext.state.errorAskForMonitoraggio, appContext.dispatch])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)} style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Monitoraggi paziente</b></Typography>}
					subheader={
						<Paper variant={"outlined"} className={clsx(classes.roundBorder, classes.padding2)}
						       style={{width: "100%", marginTop: 16}}>
							<Typography variant={"subtitle1"} color={"textSecondary"} style={{marginBottom: 8}}>
								Legenda colori (*)
							</Typography>
							<Grid container spacing={1}>
								<Grid item xs={1}>
									<PanoramaFishEyeTwoToneIcon style={{color: indigo["A700"]}}/>
								</Grid>
								<Grid item xs={2}>
									<Typography>
										SÍ
									</Typography>
								</Grid>
								
								<Grid item xs={1}>
									<PanoramaFishEyeTwoToneIcon/>
								</Grid>
								<Grid item xs={2}>
									<Typography>
										NO
									</Typography>
								</Grid>
								
								<Grid item xs={1}>
									<PanoramaFishEyeTwoToneIcon style={{color: amber[500]}}/>
								</Grid>
								<Grid item xs={5}>
									<Typography>
										NON DICHIARATO
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant={"caption"}>
										(*) Il "NON DICHIARATO" è valido solo nel monitoraggio della quarantena.
									</Typography>
								</Grid>
							</Grid>
						</Paper>
						
					}
				/>
				<CardContent style={{flexGrow: 1, overflowX: "auto"}}>
					{
						quarantena.tipo === "Isolamento" ?
							<MonitoraggiIsolamentoTable monitoraggi={quarantenaContext.state.monitoraggi}/> :
							<MonitoraggiQuarantenaTable monitoraggi={quarantenaContext.state.monitoraggi}/>
					}
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Invia una mail all'utente per sollecitare la compilazione del monitoraggio. NB: solo se la mail esiste!"}>
						<Button variant={"text"} disableElevation size="small"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={askAutocomplete}>
							<b>Invia/sollecita monitoraggio</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Visualizza su un'altra schermata tuti i monitoraggi effettuati dal paziente"}>
						<Button variant={"text"} disableElevation size="small"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={goToAllMonitoraggi}>
							<b>Vedi tutti</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Compila manualmente il monitoraggio del paziente"}>
						<Button variant={"contained"} disableElevation size="small" color="primary"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={compilaMonitoraggio}>
							<b>Compila monitoraggio</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(MonitoraggiCard)

/*
 https://ocean.aslcittaditorino.it/monitoraggio/59427/2659/wdnHehjT+Tbsif9lmavSgOyEra4b+gfIT8O9QHuAFnJkSTFci5UP8KGBqZDJRfSAkOWuxz8u64+HxLah7wFkdAsf5N863HsZdD-qJXKAfNO9wTL6p8AzuUdBzqICvX1m0X4otQDvXo0D2RowoWInLFc3XvXaSmDTsPz9j7ApfFVEau1gUKhBCPFYdW3GVUUICGeCvnKcITFfXpUym1318AVmnnYn0MabWoClskB-LldVtXvY6oah2-DeGOgMTnMKNfT+yC4Q+TwBJ7ltoVfmyNR26CDkMMcAeDCEymE3fiqkJP4BWM9MYGvaxQ38Z3cc
 * */
